import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-step-success',
  imports: [],
  templateUrl: './step-success.html',
  styleUrl: './step-success.scss',
})
export class StepSuccess {
  width = input('1rem');
  height = input('1rem');
}
